import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ModalComponent } from '../modal/modal.component';

@Component({
  selector: 'app-modal-confirmation',
  templateUrl: './modal-confirmation.component.html',
  styleUrls: ['./modal-confirmation.component.scss'],
})
export class ModalConfirmationComponent {
  @Input() payment = false;
  @Input() width = '400px';
  @Input() title = 'Confirmation';
  @Input() text = 'Are you sure?';
  @Input() cancelText = 'Cancel';
  @Input() submitText = 'Confirm';

  @Output() confirmed: EventEmitter<any> = new EventEmitter();

  @ViewChild('modal') modal!: ModalComponent;

  private data: any;

  public open(data: any = true): void {
    this.data = data;
    this.modal.open();
  }

  public cancel(): void {
    this.modal.closeAnimation();
  }

  public confirm(): void {
    this.confirmed.emit(this.data);
    this.modal.closeAnimation();
  }
}
